export const UPDATE_ENTITIES = 'UPDATE_ENTITIES';
export const UPDATE_SINGLE_ENTITY = 'UPDATE_SINGLE_ENTITY';
export const CLEAN_ENTITIES_STATE = 'CLEAN_ENTITIES_STATE';
export const TOGGLE_BY_TEAM_CHECKBOX = 'TOGGLE_BY_TEAM_CHECKBOX';
